
import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'

const actions = {
  getCollection({ commit, state }, payload) {
    API.favorites.getCollection(payload)
      .then(({ data: { data: { results }, include, meta } }) => {
        if (state.loadingIsFailed) {
          commit('setErrors', {
            status: false,
            errors: []
          })
        }

        commit('setCollectionFilters', include.filters)
        commit('updateIsLoading', false)
        commit('updateIsLoadingMore', false)
        commit('updateIsFiltering', false)

        if (meta.page === 1) {
          commit('setCollection', results)
        } else {
          commit('updateCollection', results)
        }
        commit('updatePagination', meta)
      })
      .catch(({ data: { errors } }) => {
        commit('setErrors', {
          status: true,
          errors
        })

        commit('updateIsLoading', false)
        commit('updateIsFiltering', false)
      })
  },
  filterCollection({ commit, state }, payload) {
    if (state.loadingIsFailed) {
      commit('setErrors', {
        status: false,
        errors: []
      })
    }

    commit('updateIsFiltering', true)
    commit('updateEmptyFilteringResults', false)
    commit('setCollection', [])

    API.favorites.getCollection(payload)
      .then(({ data: { data: { results }, meta } }) => {
        if (!results.length) {
          commit('updateEmptyFilteringResults', true)
        }

        commit('updateIsFiltering', false)
        commit('setCollection', results)
        commit('updatePagination', meta)
      })
      .catch(({ data: { errors } }) => {
        commit('setErrors', {
          status: true,
          errors
        })
      })
  },
  addFavorite({ commit }, payload) {
    commit('updateIsFavoriteLoading', true)

    API.favorites.add(payload)
      .then(({ data: { data: { favoriteId } } }) => {
        commit('updateFavorite', {
          hotelId: payload.hotelId,
          favoriteId
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Отель не был добавлен в избранное.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateIsFavoriteLoading', false)
      })
  },
  removeFavorite({ commit }, { ids }) {
    commit('updateIsFavoriteLoading', true)

    API.favorites.remove({ ids })
      .then(() => {
        commit('removeFavorites', ids)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Отель не был удален из избранного.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateIsFavoriteLoading', false)
      })
  },
  removeAll({ commit }) {
    API.favorites.removeAll()
      .then(() => {
        commit('setCollection', [])
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Отели не были удалены из избранного.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
  }
}

export default actions